import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useFonts = () => {
    const makFabric = useSelector((state: any) => state.makFabric)

    const handleFont = useCallback(
        (fontName: string) => {
            makFabric.setTextFont(makFabric.getSelectedText(), fontName)
        },
        [makFabric],
    )

    return {
        handleFont
    }
}